import api from './axios';

export interface SiteWheelPrize {
  id: number;
  prizeType: 'cash' | 'free_spin' | 'deposit_match' | string;
  probability: string | number;
  label: string;
  sortOrder: number;
  amount: string | number;
  depositMatchPercent: string | number;
  depositMatchMaxAmount: string | number;
  freeSpinCount: number;
  freeSpinGameId: number | null;
  freeSpinBetLevel: number | null;
}

export interface SiteWheelSettings {
  isEnabled: boolean;
  maxWinPerSpin: string | number | null;
  wageringMultiplier: string | number;
  depositMatchExpiryDays: number;
  freeSpinValidDays: number;
  prizes: SiteWheelPrize[];
}

export interface SiteWheelResponse {
  data: SiteWheelSettings;
  error: string | null;
  message: string;
  status: number;
}

export interface SiteWheelDailyConfig {
  minDepositAmount: string | number;
  lookbackDays: string | number;
}

export const siteWheelService = {
  getSettings: async (siteId: string | number): Promise<SiteWheelResponse> => {
    const response = await api.get(`/admin/site-wheel?siteId=${siteId}`);
    return response.data;
  },

  updateSettings: async (
    siteId: string | number,
    data: Partial<SiteWheelSettings>,
  ): Promise<any> => {
    const response = await api.patch(`/admin/site-wheel`, {
      siteId: Number(siteId),
      ...data,
    });
    return response.data;
  },

  updatePrizes: async (siteId: string | number, prizes: SiteWheelPrize[]): Promise<any> => {
    const response = await api.put(`/admin/site-wheel/prizes`, {
      siteId: Number(siteId),
      prizes,
    });
    return response.data;
  },

  getDailyConfig: async (siteId: string | number): Promise<any> => {
    const response = await api.get(`/admin/site-wheel/daily-config?siteId=${siteId}`);
    return response.data;
  },

  updateDailyConfig: async (
    siteId: string | number,
    data: Partial<SiteWheelDailyConfig>,
  ): Promise<any> => {
    const response = await api.put(`/admin/site-wheel/daily-config`, {
      siteId: Number(siteId),
      ...data,
    });
    return response.data;
  },

  getUserSettings: async (userId: string | number, siteId: string | number): Promise<any> => {
    const response = await api.get(`/admin/site-wheel/users/${userId}/settings?siteId=${siteId}`);
    return response.data;
  },

  updateUserSettings: async (
    userId: string | number,
    siteId: string | number,
    data: any,
  ): Promise<any> => {
    const response = await api.patch(`/admin/site-wheel/users/${userId}/settings`, {
      siteId: Number(siteId),
      ...data,
    });
    return response.data;
  },

  addUserSettingsSpins: async (
    userId: string | number,
    siteId: string | number,
    count: number,
    reason: string,
  ): Promise<any> => {
    const response = await api.post(`/admin/site-wheel/users/${userId}/spins`, {
      siteId: Number(siteId),
      count,
      reason,
    });
    return response.data;
  },
  getSpins: async (
    siteId: string | number,
    params?: { page?: number; limit?: number; sort?: string; filter?: any },
  ): Promise<any> => {
    const query = new URLSearchParams({ siteId: String(siteId) });
    if (params?.page) query.append('page', String(params.page));
    if (params?.limit) query.append('limit', String(params.limit));
    if (params?.sort) query.append('sort', params.sort);
    // Additional filters can be added here as needed
    const response = await api.get(`/admin/site-wheel/spins?${query.toString()}`);
    return response.data;
  },
};
